import { Injectable } from '@angular/core';
import { CanLoad, Route, UrlSegment } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { BrandPLPService } from '~app/modules/brand-plp/services/brand-plp.service';
import { IS_UUID } from '../../../../server/constants/regexp';
import { HomepageNavigatorService } from '~shared/modules/homepage-navigator/homepage-navigator.service';

@Injectable({
  providedIn: 'root',
})
export class BrandPLPGuard implements CanLoad {
  constructor(
    private router: HomepageNavigatorService,
    private brandPLPService: BrandPLPService
  ) {}

  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> | boolean {
    const slugSegment = segments[1];
    if (slugSegment?.path) {
      const brandSlug = slugSegment.path;

      // Check if navigation is made from brand UUID
      if (IS_UUID.test(brandSlug)) {
        return this.router.navigateToHomepage();
      }

      return this.brandPLPService.getBrandInfo(brandSlug).pipe(
        switchMap((brandInfoResponse) => {
          if (brandInfoResponse?.id) {
            return of(true);
          }
          return this.router.navigateToHomepage();
        }),
        catchError((err) => {
          return this.router.navigateToHomepage();
        })
      );
    }
    return this.router.navigateToHomepage();
  }
}
